/* global Symbol */
// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
import React, { PropTypes, Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { withRouter } from 'react-router';

import { skillCategoryTypesByTenant } from '../../../../../redux/helpers/staticData';
import ButtonGroup from '../../../../../common/components/c_ButtonGroup';
import FlatButton from '../../../../../common/components/c_FlatButton';
import TopNavigation from '../TopNavigation';

import SubmissionBar from '../../../SubmissionBar';
import * as jobRequestApi from '../../../../../redux/actionCreators/async/jobrequests';
import * as jobRequestStore from '../../../../../redux/actionCreators/sync/jobrequests';

import RouteTransitionBlocker from '../../../../r_ApplicantDashboard/f_RouteTransitionBlocker';

// js utilities
import {get, keyBy, keysIn, reduce, valuesIn, orderBy, isEmpty, cloneDeep, debounce, remove, filter, merge, set, map} from 'lodash';

import SearchIcon from '../../../../../common/svgs/SearchIcon';

// const links = [
//   {
//     name: 'Special Areas of Knowledge',
//     categoryId: 4,
//     next: 'skills/5',
//     previous: 'adddocuments',
//     max: 3,
//     categoryDescription: 'Please select a maximum of three special areas of knowledge for this position.'
//   },
//   {
//     name: 'Management Systems',
//      categoryId: 5,
//      next: 'skills/8',
//      previous: 'skills/4',
//      categoryDescription: 'Please select management system(s) for this position.'
//   },
//   {
//     name: 'Carrier Knowledge',
//     categoryId: 8,
//     next: 'skills/7',
//     previous: 'skills/5',
//     categoryDescription: 'Please select a maximum of three carriers with which you would like your wahve to have experience.'
//   },
//   {
//     name: 'Rating Systems',
//     categoryId: 7, next:
//     'skills/6',
//     previous: 'skills/8',
//     categoryDescription: 'Please select the rating system(s) for this position.'
//   },
//   {
//     name: 'Computer Skills',
//     categoryId: 6,
//     next: 'skills/9',
//     previous: 'skills/7',
//     categoryDescription: 'Please select the computer skills for this position.'
//   },
//   {
//     name: 'Foreign Language',
//     categoryId: 9,
//     next: 'skills/summary',
//     previous: 'skills/6',
//     categoryDescription: 'Please select the foreign language that is important for this position.'
//   }
// ];

@connect((store, props) => {
  const {
    skillCategoryTypes = [],
    account = {}
  } = store.staticData;
  const categoryTypes = skillCategoryTypesByTenant(account.id, skillCategoryTypes, 'showInJobRequest');

  const links = categoryTypes.map((skillType, index, arr) => {
    const isFirst = index === 0;
    const isLast = index === arr.length - 1;
    const prevSkillCategoryId = isFirst ? null : arr[index - 1].id;
    const nextSkillCategoryId = isLast ? null : arr[index + 1].id;

    const link = {
      name: skillType.name,
      categoryId: skillType.id,
      description: skillType.jobRequestDescription
    };

    if (isFirst) {
      set(link, 'previous', 'adddocuments');
      set(link, 'next', `skills/${nextSkillCategoryId}`);

    } else if (isLast) {
      set(link, 'previous', `skills/${prevSkillCategoryId}`);
      set(link, 'next', 'skills/summary');

    } else {
      set(link, 'previous', `skills/${prevSkillCategoryId}`);
      set(link, 'next', `skills/${nextSkillCategoryId}`);
      set(link, 'description', skillType.jobRequestDescription);
    }

    return link;
  });

  const skills = keyBy(get(store.jobRequest, `skills.${props.params.categoryId || links[0].categoryId}`, {}), 'name');
  const currentCategory = get(keyBy(links, 'categoryId'), props.params.categoryId || links[0].categoryId);

  return {
    staticData: store.staticData,
    user: store.user,
    contact: store.contactProfile,
    jobRequest: store.jobRequest,
    categoryId: parseInt(props.params.categoryId || links[0].categoryId, 10),
    currentCategory,
    jobId: parseInt(props.params.jobId || 0, 10),
    skills,
    links,
    labels: get(store, 'labels.jobRequest.skills', {}),
  };
})
class JobRequestSkills extends Component {
  static propTypes = {
    params: PropTypes.object,
    staticData: PropTypes.object,
    links: PropTypes.array,
  }

  constructor(props, context) {
    super(props, context);

    // setting initial state
    this.state = {
      skills: this.props.skills,
      searchTags:[],
      errors: [],
      showError: false,
      showTransitionBlocker: false,
      transitionRoute: '',
      stateSaved: true
    };
  }

  componentDidMount() {
    this.props.router.setRouteLeaveHook(this.props.route, (location) => {

			const jobRequestSteps = /\/client\/jobrequest\/(.*)\/?(.*)/;

			if (jobRequestSteps.test(location.pathname)) {

				this.state.primaryButtonLabel = 'Stay';
				this.state.secondaryButtonLabel = 'Leave';

			}else{
				this.state.primaryButtonLabel = undefined;
				this.state.secondaryButtonLabel = undefined;
			}

      if (!this.state.stateSaved) {
      this.setState(merge({}, this.state, {showTransitionBlocker: true, transitionRoute: location.pathname}));
    }
    return this.state.stateSaved;
  });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.skills) {
      this.setState({showError: false, searchTags:[]});
      this.validation(nextProps.skills);
    }
  }

  onChange(event, value) {
    const skills = reduce(value, (category, skill) => {
        category[skill] = get(this.state.skills, skill) ? this.state.skills[skill] : { categoryId:this.props.categoryId, name: skill };
        return category;
      }, {});
    this.validation(skills);
    this.setState({stateSaved:false});

  }

  validation(skills) {
    const errors = [];
    if (isEmpty(skills)) {
      errors.push('Please Select at Least One Item.');
    }
    else if (this.props.currentCategory.max  && keysIn(skills).length > this.props.currentCategory.max) {
      errors.push(`Please Select maximum of ${this.props.currentCategory.max} Items.`);
    }
    this.setState({skills, errors});

    return errors.length ? true : false;
  }


  updateStoreAfterSaved = (skills) => {
    const updatedSkills = valuesIn(skills);
    const updatedJobRequestStore = cloneDeep(this.props.jobRequest);
    set(updatedJobRequestStore, `skills[${this.props.categoryId}]`, updatedSkills);
    this.props.dispatch(jobRequestStore.updateJobRequest({...updatedJobRequestStore}));
  }

  save = (skills) => {

    const updatedSkills = valuesIn(skills);

    const updatedJobRequest = {
      id: this.props.jobId,
      primaryContactId: this.props.contact.profile.id,
      skills: {}
    };

    updatedJobRequest.skills[`${this.props.categoryId}`] = updatedSkills;

    const updateJobRequest = (jobId, jobRequest) =>  this.props.dispatch(jobRequestApi.updateJobRequest(jobId, jobRequest));

    return updateJobRequest(this.props.jobId, updatedJobRequest).then(
      () => {
        this.updateStoreAfterSaved(this.state.skills);
        this.props.checkComplete();
      });

  }

  gotoNextScreen =  () => {

      const skillsInCategory = filter(this.props.skills, {categoryId: this.props.currentCategory.categoryId});
      const hasErrors = this.validation(skillsInCategory);

      if(hasErrors) {
        this.setState({showError: true});
        return;
      }

      this.props.checkComplete();
      this.props.dispatch(push(`/client/jobrequest/${this.props.jobId||0}/${this.props.currentCategory.next}`));
  }

  handleSave = (event, cb) => {

    // We should not save if there not jobId.

    if(!this.props.jobId) {
      return false;
    }

    this.save(this.state.skills)
      .then(() => this.setState({ stateSaved: true }, cb));

  }

  handleSaveAndNext = (event) => {

    const hasErrors = !isEmpty(this.state.errors);

    this.handleSave(event, () => {
      if (hasErrors) {
        this.setState({showError: true});
      } else {
        this.gotoNextScreen();
      }
    });
  }


  handleBack = () => {
    this.props.dispatch(push(`/client/jobrequest/${this.props.jobId||0}/${this.props.currentCategory.previous}`));
  }

  handleDelete(event, value) {
    const values = remove(keysIn(this.state.skills), s => s !== value);
    this.onChange(event, values);
  }

  searchOnChange = (event) => {
    debounce(
      this.setState({
        searchTags: event.target.value.toLowerCase().trim()
      }), 200);
  }
  closeTransitionBlocker = () => {
    this.setState(merge({}, this.state, {showTransitionBlocker: false}));
  }

	transitionFunction = () => {
		this.setState({stateSaved: true, showTransitionBlocker: false}, () =>  this.props.dispatch(push(this.state.transitionRoute)));
	}

  render() {
    const values = keysIn(this.state.skills);
    const list = reduce(orderBy(this.props.staticData.skillTypes, ['name'], ['asc']),
      (skillsList, skill) => {
          if (skill.skillCategoryTypeId === this.props.categoryId) {
            skillsList.push({primaryText: skill.name});
          }
          return skillsList;
        },
      []);

    list.unshift({primaryText: 'None'});

    const visibleList = reduce(list,
        (skillsList, skill) => {
            if (this.state.searchTags === '' || skill.primaryText.toLowerCase().indexOf(this.state.searchTags) > -1) {
              skillsList.push(skill.primaryText);
            }
            return skillsList;
          },
        []);

    return (
      <div className='job-request-skills'>
    {
      this.state.showTransitionBlocker
      &&
      <RouteTransitionBlocker
        cancelAction={this.closeTransitionBlocker.bind(this)}
        primaryAction={this.closeTransitionBlocker.bind(this)}
        primaryButtonLabel={this.state.primaryButtonLabel}
        secondaryAction={this.transitionFunction.bind(this)}
        secondaryButtonLabel={this.state.secondaryButtonLabel}
        transitionText={'You are leaving the Job Request record. Please click on Save first before you exit.'}
      />
    }
        <TopNavigation
          activeCategoryId={this.props.categoryId}
          links={this.props.links}
          jobId={this.props.jobId}
          dispatch={this.props.dispatch}
          jobRequest={this.props.jobRequest}
        />

        <div>

          <div className='job-request-skills-body'>
            <h1>Skills</h1>
            <h2>{this.props.labels.instructions}</h2>
            <div className='skills-container'>
              <div className='category'>{this.props.currentCategory.title}</div>
              {
                this.props.currentCategory.description &&
                <div className='category-description'>
                  {this.props.currentCategory.description}
                </div>
              }
               <br />
                {
                 <div className='search center-column-3'>
                    <div className='search-input-container'>
                      <SearchIcon />
                      <input data-id='Search'
                             ref='search'
                             className='search-input'
                             value={this.state.searchTags}
                             type='text'
                             placeholder='Search...'
                             onChange={::this.searchOnChange}/>
                    </div>
                  </div>
                }
              <div className='skills-list-container'>
                <ButtonGroup
                  menuItems={list}
                  visibleItems={visibleList}
                  value={values}
                  onChange={::this.onChange}
                />
                <ul className={`skill-list-client ${values.length ? '' : 'empty'}`}>
                  {
                    map(values, (value, index) => (
                      <li key={index} className='skill-item'>
                        <div data-id={`SkillName${index}`} className='name'>{value}</div>
                        <div className='actions'>
                          <FlatButton
                            data-id={`Remove${index}`}
                            label='Remove'
                            data-id={`Remove${index}`}
                            onClick={(event) => {this.handleDelete(event, value);}}
                          />
                        </div>
                      </li>
                    ))
                  }
                </ul>
              </div>
            </div>
          </div>
          <SubmissionBar
            onBack={this.handleBack}
            onNext={this.handleSaveAndNext}
            onSave={this.handleSave}
            errors={this.state.errors}
            showError={this.state.showError}
          />
        </div>
      </div>
    );
  }
}
export default withRouter(JobRequestSkills);



// WEBPACK FOOTER //
// ./shared/react/client/JobRequest/Skills/JobRequestSkills/index.js